import { render, staticRenderFns } from "./confirmarPedidoModal.vue?vue&type=template&id=1ec99f4c&scoped=true&"
import script from "./confirmarPedidoModal.vue?vue&type=script&lang=js&"
export * from "./confirmarPedidoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec99f4c",
  null
  
)

export default component.exports